module.exports = __webpack_public_path__ + "58168d6251dfcbbe3e851c8da489479b.svg";